import { createStore } from 'vuex';
import message from '@/store/modules/message';
import appConfig from '@/store/modules/appConfig';
import feedback from '@/store/modules/feedback';
import routing from '@/store/modules/routing';
import FAQ from '@/store/modules/FAQ';
import { DEFAULT_LANG } from '@/constants/settings';
import documents from '@/store/modules/documents';
import keyControl from '@/store/modules/keyControl';
import { locales } from '@/modules/locales/setup';

export default createStore({
    state: {
        urlParams: {},
        queryParams: {},
    },
    mutations: {
        setUrlParams(state, urlParams) {
            if (!urlParams.lang || locales.languages.indexOf(urlParams.lang) === -1) {
                urlParams.lang = DEFAULT_LANG;
            }
            state.urlParams = urlParams;
        },
        setQueryParams(state, urlParams) {
            const query = {};
            for (const [key, value] of Object.entries(urlParams)) {
                if (key !== 'page') query[key] = value;
            }
            state.queryParams = query;
        },
    },
    modules: {
        appConfig,
        routing,
        message,
        feedback,
        FAQ,
        documents,
        keyControl
    }
})
